export enum LegalEntity {
  ItrBEL = 'ITR-BEL',
  ItrGEO = 'ITR-GEO',
  ItrLIT = 'ITR-LIT',
  ItrPL = 'ITR-PL',
  ItrUZ = 'ITR-UZ',
}
